/**
 * @module app.cm
 */

import { FrameworkConfiguration } from 'aurelia-framework';
import { CaseManagementModule } from './module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(CaseManagementModule.registrationKey, CaseManagementModule);

    config.globalResources([
        // elements

        // value converters
        './value-converters/filter-diagnoses-converter',  //TODO: This may not be being used. Check CM Member Diagnoses. A filter function may have replaced this
        './value-converters/task-type-converter'
    ]);
}
